export const SocialMediaDetailsData = [
  {
    icon:"jam:facebook",
    title:'FACEBOOK',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"ri:instagram-line",
    title:'INSTAGRAM',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"ri:linkedin-fill",
    title:'LINKEDIN',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"iconoir:snapchat" ,
    title:'SNAPCHAT',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"prime:twitter"  ,
    title:'TWITTER',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"mdi:youtube",
    title:'YOUTUBE',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },

]